import api from "../../../api";

export const requestGetCar = (id) => api.get(`/admin/usercars/${id}`);
